<div>
  <div
    fxlayout="row"
    fxLayoutAlign="left center"
    fxLayoutGap="8px">
    <div fxFlex="33">
      <input
        [(ngModel)]="dayValue"
        class="input is-small"
        type="number"
        min="0"
        [max]="maxDays"
        [placeholder]="'MANAGEMENT.DATASETS.DAYS' | translate"
        (change)="numberFieldChanged($event)" />
      <div class="sub-text">{{ 'MANAGEMENT.DATASETS.DAYS' | translate }}</div>
    </div>
    <div fxFlex="33">
      <input
        [(ngModel)]="hourValue"
        class="input is-small"
        type="number"
        min="0"
        [max]="maxHours"
        [placeholder]="'MANAGEMENT.DATASETS.HOURS' | translate"
        (change)="numberFieldChanged($event)" />
      <div class="sub-text">{{ 'MANAGEMENT.DATASETS.HOURS' | translate }}</div>
    </div>
    <div fxFlex="33">
      <input
        [(ngModel)]="minuteValue"
        class="input is-small"
        type="number"
        min="0"
        [max]="maxMinutes"
        [placeholder]="'MANAGEMENT.DATASETS.MINUTES' | translate"
        (change)="numberFieldChanged($event)" />
      <div class="sub-text">{{ 'MANAGEMENT.DATASETS.MINUTES' | translate }}</div>
    </div>
  </div>
</div>
